module.exports = __webpack_public_path__ + "static/custom-script-bulk-product-videos-0d9df6141fb096635b91ec7dd0443552.png";